var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5V15.9167L3.75 14.6667V17.5H2.5ZM5.9375 17.5V12.5833L7.1875 11.3333V17.5H5.9375ZM9.375 17.5V11.3333L10.625 12.6042V17.5H9.375ZM12.8125 17.5V12.6042L14.0625 11.3542V17.5H12.8125ZM16.25 17.5V9.25L17.5 8V17.5H16.25ZM2.5 12.5833V10.8125L8.33333 5.02083L11.6667 8.35417L17.5 2.5V4.27083L11.6667 10.125L8.33333 6.79167L2.5 12.5833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.de65a55628e43d7bade75c893509f61f.svg";
export { ForwardRef as ReactComponent };